import { IdlePeriodSettingsFormModel } from 'src/Libs/smart-charge/models'
import { IdlePeriodsSettingsUpdateDto } from 'src/Libs/smart-charge/dto'
import { humanTimeToSecondsFromMidnight } from '@e3dc-react/shell/Libs/date'

const settingsFormToDtoTransformer = (formValues: IdlePeriodSettingsFormModel): IdlePeriodsSettingsUpdateDto => {
  return {
    emsGetIdlePeriodsEnable: formValues.emsGetIdlePeriodsEnable,
    emsIdlePeriod: formValues.emsIdlePeriod.map(item => ({
      emsPeriodName: item.description,
      emsPeriodWeekdays: item.daysOfWeek,
      emsPeriodType: item.type,
      emsPeriodActive: item.isActive,
      emsPeriodStart: humanTimeToSecondsFromMidnight(item.startTimeOfDay),
      emsPeriodStop: humanTimeToSecondsFromMidnight(item.endTimeOfDay),
    })),
  } as IdlePeriodsSettingsUpdateDto
}
export default settingsFormToDtoTransformer
